import Swiper from 'swiper';
import {Scrollbar, Pagination} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';

window.addEventListener('DOMContentLoaded', (event) => {
    const swiperrelPT = new Swiper('.swiperrelPT', {
        modules: [Scrollbar, Pagination],
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 20,

        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },

        pagination: {
            el: ".swiper-pagination",
        },

    });
});

